import { defineBrowserModule } from "@amtana/browser";
import type { BrowserModule } from "@amtana/browser";
import { phrase } from "@amtana/i18n/catalog";

import { INTEGRATION_CATALOGS } from "./model/integration-copy.ts";
import { INTEGRATION_ERROR_COPY } from "./model/integration-error-copy.ts";

// Settings → Enterprise hides behind `enterprise-settings` (S43.05, D1370).
export const integrationBrowserModule: BrowserModule = defineBrowserModule("integration")
  .withErrorCopy(INTEGRATION_ERROR_COPY)
  .withScreens({
    integrations: {
      path: "/integrations",
      title: phrase(INTEGRATION_CATALOGS, "screenTitle"),
      layout: "app",
      flag: "enterprise-settings",
      load: () => import("./ui/sections/integrations-screen.tsx"),
    },
  })
  .withNavigation([
    {
      id: "integrations",
      group: "settings-enterprise",
      label: phrase(INTEGRATION_CATALOGS, "navIntegrations"),
      href: "/integrations",
      icon: "puzzle",
      order: 876,
      flag: "enterprise-settings",
    },
  ]);
